<template>
  <div class="content">
    <div class="header-info">
      <div class="left">
        <span class="label">工号：</span>
        <span class="value">{{ dispname }}</span>

        <div v-if="isphy == '1'" class="sign-btn-wrapper">
          <van-button v-if="issign === '0'" type="primary" size="small" @click="handleSignIn(1)">签到</van-button>
          <van-button v-else type="warning" size="small" @click="handleSignIn(2)">退签</van-button>
        </div>

      </div>
      <div class="right">
        <span class="label">诊所：</span>
        <span class="value">{{ clinicname }}</span>
      </div>
    </div>

    <div v-if="doctorArea && doctorArea.length">
      <div class="area-title">
        医生工作区
      </div>
      <div class="home">
        <div class="list" v-for="item in doctorArea" @click="changeRouter(item.url)">
          <div class="img">
            <img :src="item.img" alt="">
          </div>
          <div class="title">{{ item.menu_name }}</div>
        </div>
      </div>
    </div>

    <div v-if="pharmacyArea && pharmacyArea.length">
      <div class="area-title">
        药房工作区
      </div>
      <div class="home">
        <div class="list" v-for="item in pharmacyArea" @click="changeRouter(item.url)">
          <div class="img">
            <img :src="item.img" alt="">
          </div>
          <div class="title">{{ item.menu_name }}</div>
        </div>
      </div>
    </div>

    <div v-if="csArea && csArea.length">
      <div class="area-title">
        客服工作区
      </div>
      <div class="home">
        <div class="list" v-for="item in csArea" @click="changeRouter(item.url)">
          <div class="img">
            <img :src="item.img" alt="">
          </div>
          <div class="title">{{ item.menu_name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {wxtriageworkbenchqry, wxgetsigninfo, wxphysiotherapistsignin} from '@/api/medical'
import { mapGetters } from 'vuex'
import { Dialog, Toast } from 'vant'
export default{
    computed: {
        ...mapGetters([
            'username','dispname','clinicid','clinicname'
        ]),
    },
    data(){
        return{
            doctorArea:[],
            pharmacyArea:[],
            csArea:[],
            isphy: 0,
            issign: 0,
            ishelp: 0,
            menuData: null,
            signData: null
        }
    },
    created(){
        this.$store.dispatch('hideOrShowNav', true)
        this.initData()
    },
    beforeRouteLeave(to, from, next){

        this.$store.dispatch('changeIsRefresh', '1')

        next()
    },
    methods:{
        changeRouter(url){
            console.log(url);
            if(url){
                if(url == 'help_start'){
                    this.handleSignIn(3)
                    return
                }
                if(url == 'help_end'){
                    this.handleSignIn(4)
                    return
                }
                if(url=='/processDispensing'){
                    this.$router.push({path:'/dispensing',query:{isprocess:1}})
                  return
                }
                if (url == '/chargeWorkbench'){
                  this.$store.dispatch('changeIsRefresh', '1')
                }
                this.$router.push(url)
            }
        },
        initData(){
            Promise.all([
                this.getmenu(),
                this.getSignInfo()
            ]).then(() => {
                this.processMenu()
            })
        },
        getmenu(){
            return new Promise((resolve) => {
                let data ={
                    username:this.username
                }
                wxtriageworkbenchqry(data).then(response =>{
                    // 同步服务器时间
                    const serverTime = Number(response.response_body.servicetime)

                    if (serverTime) {
                      const offset = serverTime - Date.now()

                      localStorage.setItem(
                          'ServerTimeOffset',
                          offset
                      )

                      this.$store.commit(
                          'SET_SERVER_TIME_OFFSET',
                          offset
                      )
                    }
                    this.menuData = response.response_body.list
                    resolve()
                }).catch(() => {
                    this.menuData = []
                    resolve()
                })
            })
        },
        getSignInfo(){
            return new Promise((resolve) => {
                let data = {
                    username: this.username,
                    clinicid: this.clinicid
                }
                wxgetsigninfo(data).then(response => {
                    if(response.response_body){
                        this.isphy = response.response_body.isphy || 0
                        this.issign = response.response_body.issign || 0
                        this.ishelp = response.response_body.ishelp || 0
                    }
                    this.signData = response.response_body || {}
                    resolve()
                }).catch(() => {
                    this.signData = {}
                    resolve()
                })
            })
        },
        processMenu(){
            if(this.menuData){
                this.doctorArea = this.menuData
                    .filter(item => ['treatWorkbench', 'visitWorkbench','aiIdentify'].includes(item.menu_code))
                    .map(item => {
                    if(item.menu_code == 'treatWorkbench'){
                        item.url = '/treatPage'
                        item.img = require('@/assets/physicalwork.png')
                    }else if(item.menu_code == 'visitWorkbench'){
                        item.url = '/seePage'
                        item.img = require('@/assets/visitwork.png')
                    }else if(item.menu_code == 'aiIdentify'){
                      item.url = '/aiIdentify'
                      item.img = require('@/assets/aiIdentify.png')
                    }
                    return item
                })

              this.pharmacyArea = this.menuData
                  .filter(item => ['dispensing', 'processDispensing'].includes(item.menu_code))
                  .map(item => {
                    if(item.menu_code == 'dispensing'){
                      item.url = '/dispensing'
                      item.img = require('@/assets/dispensing.png')
                    }else if(item.menu_code == 'processDispensing'){
                      item.url = '/processDispensing'
                      item.img = require('@/assets/processDispensing.png')
                    }
                    return item
                  })

              this.csArea = this.menuData
                  .filter(item => ['reportTriage', 'bookingManagement', 'patientList','chargeWorkbench'].includes(item.menu_code))
                  .map(item => {
                    if(item.menu_code == 'reportTriage'){
                      item.url = '/registrationDesk'
                      item.img = require('@/assets/reportTriage.png')
                    }else if(item.menu_code == 'bookingManagement'){
                      item.url = '/bookingManagement'
                      item.img = require('@/assets/bookingManagement.png')
                    }else if(item.menu_code == 'patientList'){
                      item.url = '/patientList'
                      item.img = require('@/assets/patientlist.png')
                    }else if(item.menu_code == 'chargeWorkbench'){
                      item.url = '/chargeWorkbench'
                      item.img = require('@/assets/chargePage.png')
                    }
                    return item
                  })
            }

            this.addHelpButton()
        },
        addHelpButton(){
            let helpBtn = {
                menu_name: this.ishelp == 1 ? '结束助诊' : '开始助诊',
                url: this.ishelp == 1 ? 'help_end' : 'help_start',
                img: require('@/assets/isHelpIcon.png')
            }
            this.doctorArea.push(helpBtn)
        },
        handleSignIn(type){
            let title = '';
            let message = '';
            let loadingMessage = '';
            if (type === 1){
              title = '确认签到';
              message = '确定要进行签到吗？';
              loadingMessage = '签到中...';
            }else if(type === 2){
              title = '确认签退';
              message = '确定要进行退签吗？';
              loadingMessage = '退签中...';
            }else if(type === 3){
              title = '确认助诊';
              message = '确定要进行助诊吗？';
              loadingMessage = '确认助诊中...';
            }else if(type === 4){
              title = '结束助诊'
              message = '确定要结束助诊吗？'
              loadingMessage = '结束助诊中...';
            }

            Dialog.confirm({
                title,
                message,
            })
            .then(() => {
                let data = {
                    username: this.username,
                    clinicid: this.clinicid,
                    oprtype: type
                }
                Toast.loading({
                    message: loadingMessage,
                    forbidClick: true
                })
                wxphysiotherapistsignin(data).then(response => {
                  if (Toast) {
                    Toast.clear();
                  }
                  if(response.response_body){
                    if (response.response_body.success){
                      Toast.success(response.response_body.message)
                      this.initData()
                    }else{
                      Toast.fail(response.response_body.message)
                    }
                  }

                }).catch(() => {
                    Toast.clear()
                })
            })
            .catch(() => {
            })
        },
    }
}

</script>
<style lang="scss" scoped>
.content{
  margin: 0;
  padding: 50px 20px 20px;
}
.header-info{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #FFF2E1;
  box-shadow: 0 2px 8px rgba(230, 159, 18, 0.1);
  height: 32px;

  .left, .right{
    display: flex;
    align-items: center;
    .label{
      font-size: 12px;
      color: #8B6914;
    }
    .value{
      font-size: 12px;
      font-weight: 600;
      color: #5D4E37;
      margin-left: 4px;
    }
  }
  .sign-btn-wrapper{
    display: flex;
    justify-content: center;
    ::v-deep .van-button{
      background: transparent;
      color: #FF9008;
      border: none;
    }
  }
}
.area-title{
  font-size: 16px;
  font-weight: bold;
}
.home{
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;

    .list{
        width: 33%;
        text-align: center;
        margin-bottom: 40px;
        .img{
            display: flex;
            justify-content: center;
        }
        img{
            width: 50px;
            height: 50px;
            border-radius: 50px;
        }
    }
}
</style>
